import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Environment, environmentToken } from '@environment';
import { Observable } from 'rxjs';
import { AuditDetails, AuditDetailsConnections, Auth0Connection } from '@app/shared/models/audit-details.interface';

@Injectable({
  providedIn: 'root'
})
export class AuditResource {
  private readonly baseUrl: string;

  constructor(private http: HttpClient, @Inject(environmentToken) environment: Environment) {
    this.baseUrl = environment.apiUrl + environment.apiPath;
  }

  getAuditDetailsForBuilding(buildingId: number): Observable<AuditDetails> {
    return this.http.get<AuditDetails>(`${this.baseUrl}/audit/details/building/${buildingId}`);
  }

  save(auditDetails: AuditDetails): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/audit/details`, auditDetails);
  }

  getAvailableConnections(): Observable<Auth0Connection[]> {
    return this.http.get<Auth0Connection[]>(`${this.baseUrl}/auth0-data/connections/SAML`);
  }

  getBuildingConnections(buildingId: number): Observable<AuditDetailsConnections[]> {
    return this.http.get<AuditDetailsConnections[]>(`${this.baseUrl}/audit/details/building/${buildingId}/connections`);
  }

  updateBuildingConnections(buildingId: number, connections: string[]): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/audit/details/building/${buildingId}/connections`, connections);
  }
}
